export default "__VITE_ASSET__CwTNR3Bd__"